import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { BusinessUserResource, syncMessage } from 'src/app/interfaces/business-user-resource';
import { CardResource } from 'src/app/interfaces/card-resouce';
import { EventResource } from 'src/app/interfaces/event-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { CardService } from 'src/app/services/card.service';
import { EnvironmentService } from 'src/app/services/environment.service';
import { LoadingService } from 'src/app/services/loading.service';
import { McpService } from 'src/app/services/mcp.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  page = null;
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }
  hasERPSync:boolean =false;
  customerTypes = [
    { value: "MAINCUSTOMER", viewValue: "Hauptkunde" },
    { value: "SUBCUSTOMER", viewValue: "Haushaltsmitglied" }
  ]

  portalStates = [
    { value: "ACTIVE", viewValue: "Aktiv" },
    { value: "PENDING", viewValue: "Wartend" },
    { value: "DISABLE_REQUEST", viewValue: " Deaktivierung beantragt" },
    { value: "REJECTED", viewValue: "Abgelehnt" },
    { value: "DISABLED", viewValue: "Deakiviert" },
    { value: "DELETED", viewValue: "Gelöscht" },
    { value: "NEW", viewValue: "Neu" }
  ]

  contractStates = [
    { value: "RUNNING", viewValue: "Läuft" },
    { value: "CANCELLED", viewValue: "Gekündigt" },
    { value: "FINISHED", viewValue: "Beendet" }
  ]

  cardStates = [
    { value: "CREATED", viewValue: "Erstellt" },
    { value: "AVAILABLE", viewValue: "Verfügbar" },
    { value: "REQUESTED", viewValue: "Angefordert" },
    { value: "ASSIGNED", viewValue: "Zugeordnet" },
    { value: "ACTIVE", viewValue: "Aktiv" },
    { value: "CLOSE_REQUEST", viewValue: "Sperrung beantragt" },
    { value: "CLOSED", viewValue: "Gesperrt" },
  ]

  erpStates = [
    { value: "MATCH", viewValue: "Übereinstimmung" },
    { value: "PARTIAL_MATCH", viewValue: "Partielle Übereinstimmung" },
    { value: "NO_MATCH", viewValue: "Keine Übereinstimmung" },
    { value: "IGNORE", viewValue: "Nie überschreiben" }
  ]
  showMoreFilter: boolean = false;
  filterForm: UntypedFormGroup;
  dataSource: MatTableDataSource<BusinessUserResource>;
  isActive = false;
  isFormFilterActivate: boolean = false;
  isFormFilterDeactivate: boolean = false;
  // 'contracts',
  displayedColumns = ['number', 'user', 'address', 'contact', 'type', 'state', 'menu'];
  usesCustomerCard: boolean = false;
  usesEnergyContracts: boolean = false;
  type:string = '';
  loading:boolean = true;
  usesSSO: boolean = false;
  constructor(
    private businessuserService: BusinessuserService,
    private fb: UntypedFormBuilder,
    private overlay: OverlayService,
    private environment: EnvironmentService,
    private route: ActivatedRoute,
    private router: Router,
    private cardService:CardService,
    private mcp: McpService) {

    this.mcp.loadConfiguration().subscribe(config => {
      this.usesCustomerCard = config.usesCustomerCard;
      this.usesEnergyContracts = config.usesEnergyContracts;
      this.hasERPSync = config.hasERPSync;
      this.usesSSO = config.usesSSO;
    })

    this.filterForm = this.fb.group({
      searchTerm: [null],
      filterByCustomerType: [null],
      filterByState: [null],
      filterBySupplyContractState: [null],
      filterByCardState: [null],
      erpState: [null],
      hasNoValidELV: null,
      hasNoCard: null
    })
  }

  ngOnInit() {
    this.loading = true;
    this.route.queryParams.subscribe(params => {
      this.filterForm.markAllAsTouched();

      if(params?.hasNoCard){
        this.type = 'Karten erstmalig drucken';
      }

      if(params?.filterByCustomerType == 'MAINCUSTOMER,SUBCUSTOMER' && params?.filterByState == 'ACTIVE' && params?.filterByCardState == 'CLOSE_REQUEST'){
        this.type = 'Karten erneut drucken';
      }

      this.filterForm.patchValue({
        searchTerm: params?.searchTerm,
        filterByCardState: ((params?.filterByCardState != '') ? params?.filterByCardState?.split(',') : null),
        erpState: params?.erpState,
        filterByCustomerType: ((params?.filterByCustomerType != '') ? params?.filterByCustomerType?.split(',') : null),
        hasNoValidELV: params?.hasNoValidELV,
        filterByState: ((params?.filterByState != '') ? params?.filterByState?.split(',') : null),
        hasNoCard: params?.hasNoCard,
      })
      if (params?.page) {
        this.pageData.pageIndex = params?.page;
      }
      if (params?.size) {
        this.pageData.pageSize = params?.size;
      }
    })

    this.businessuserService.getAllBusinessUsersWtihFilter(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.searchTerm, this.filterForm.value.filterByCustomerType, this.filterForm.value.filterByState, this.filterForm.value.filterBySupplyContractState, this.filterForm.value.filterByCardState, this.filterForm.value.erpState, this.filterForm.value.hasNoValidELV, this.filterForm.value.hasNoCard).subscribe((fromSearch: PagedResources<BusinessUserResource>) => {
      this.page = fromSearch.page;
      fromSearch.content.forEach(user => {
        this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
          user['household'] = el;
        })
      });
      this.dataSource = new MatTableDataSource(fromSearch.content);
       this.loading = false;
    })
  }

  loadPage(event?: PageEvent) {
    this.pageData.pageIndex = event.pageIndex;
    this.pageData.pageSize = event.pageSize;
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          page: event.pageIndex,
          size: event.pageSize,
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        return this.search(event.pageIndex, event.pageSize);
      })
  }

  search(pageIndex, pageSize) {
    this.businessuserService.getAllBusinessUsersWtihFilter(pageIndex, pageSize, this.filterForm.value.searchTerm, this.filterForm.value.filterByCustomerType, this.filterForm.value.filterByState, this.filterForm.value.filterBySupplyContractState, this.filterForm.value.filterByCardState, this.filterForm.value.erpState, this.filterForm.value.hasNoValidELV, this.filterForm.value.hasNoCard)
      .subscribe((users: PagedResources<BusinessUserResource>) => {
        this.page = users.page
        users.content.forEach(user => {
          this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
            user['household'] = el;
          })
        });
        this.dataSource = new MatTableDataSource(users.content);
        this.loading = false;
      })
  }

  filterCustomers() {

    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {

          searchTerm: this.filterForm.value?.searchTerm,
          filterByCardState: this.filterForm.value?.filterByCardState?.join(),
          erpState: this.filterForm.value?.erpState,
          filterByCustomerType: this.filterForm.value?.filterByCustomerType?.join(),
          hasNoValidELV: this.filterForm.getRawValue()?.hasNoValidELV,
          filterByState: this.filterForm.value?.filterByState?.join(),
          hasNoCard: this.filterForm.value?.hasNoCard
        },
        queryParamsHandling: 'merge'
      }).then(res => {
        this.loading = true;
        this.isFormFilterActivate = false;
        this.isFormFilterDeactivate = false;
        this.filterForm.markAllAsTouched();
        this.businessuserService.getAllBusinessUsersWtihFilter(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.searchTerm, this.filterForm.value.filterByCustomerType, this.filterForm.value.filterByState, this.filterForm.value.filterBySupplyContractState, this.filterForm.value.filterByCardState, this.filterForm.value.erpState, this.filterForm.value.hasNoValidELV, this.filterForm.value.hasNoCard).subscribe((users: PagedResources<BusinessUserResource>) => {
          this.page = users.page
          users.content.forEach(user => {
            this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
              user['household'] = el;
            })
          });
          this.dataSource = new MatTableDataSource(users.content);
          this.loading = false;
        })
      });
  }

  showmoreFilters() {
    this.showMoreFilter = true;
  }

  showLessFilters() {
    this.showMoreFilter = false;
  }

  resetFilter() {

    this.filterForm.reset();
    this.router.navigate([],
      {
        relativeTo: this.route,
        queryParams: {
          searchTerm: this.filterForm.value?.searchTerm,
          filterByCardState: this.filterForm.value?.filterByCardState?.join(),
          erpState: this.filterForm.value?.erpState,
          filterByCustomerType: this.filterForm.value?.filterByCustomerType?.join(),
          hasNoValidELV: this.filterForm.value?.hasNoValidELV,
          filterByState: this.filterForm.value?.filterByState?.join(),
          hasNoCard: this.filterForm.value?.hasNoCard
        },
        queryParamsHandling: 'merge'
      }).then(() => {
        this.loading = true;
        this.search(this.pageData.pageIndex, this.pageData.pageSize);
   
      })
  }

  deactiveUser(customer) { 
   this.overlay.openDeactivateUserDialog("Kundenkonto sperren","",   customer.businessRole=="SUBCUSTOMER" ? "Haushaltsmitglied sperren" : "Kunde (und Haushalt) sperren","Abbrechen", customer)
  }


  deactivateUserForever(customer) {
    this.businessuserService.deactivateUserForever(customer).subscribe(value => {
      if (value) {
        this.overlay.openSnackBar("Nutzer erfolgreich deaktiviert!");
        this.businessuserService.getAllBusinessUsersWtihFilter(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.searchTerm, this.filterForm.value.filterByCustomerType, this.filterForm.value.filterByState, this.filterForm.value.filterBySupplyContractState, this.filterForm.value.filterByCardState, this.filterForm.value.erpState, this.filterForm.value.hasNoValidELV, this.filterForm.value.hasNoCard).subscribe((users: PagedResources<BusinessUserResource>) => {
          this.page = users.page
          users.content.forEach(user => {
            this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
              user['household'] = el;
            })
          });
          this.dataSource = new MatTableDataSource(users.content);
        })
      }
    })
  }

  activateUserWithoutNotification(customer) {
    this.businessuserService.activateUserWithoutNotification(customer).subscribe(value => {
      if (value) {
        this.overlay.openSnackBar("Nutzer erfolgreich aktiviert!");
        this.businessuserService.getAllBusinessUsersWtihFilter(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.searchTerm, this.filterForm.value.filterByCustomerType, this.filterForm.value.filterByState, this.filterForm.value.filterBySupplyContractState, this.filterForm.value.filterByCardState, this.filterForm.value.erpState, this.filterForm.value.hasNoValidELV, this.filterForm.value.hasNoCard).subscribe((users: PagedResources<BusinessUserResource>) => {
          this.page = users.page
          users.content.forEach(user => {
            this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
              user['household'] = el;
            })
          });
          this.dataSource = new MatTableDataSource(users.content);
        })
      }
    })
  }


  activateUserWithNotification(customer) {
    this.businessuserService.activateUserWithNotification(customer).subscribe(value => {
      if (value) {
        this.overlay.openSnackBar("Nutzer erfolgreich aktiviert!");
        this.businessuserService.getAllBusinessUsersWtihFilter(this.pageData.pageIndex, this.pageData.pageSize, this.filterForm.value.searchTerm, this.filterForm.value.filterByCustomerType, this.filterForm.value.filterByState, this.filterForm.value.filterBySupplyContractState, this.filterForm.value.filterByCardState, this.filterForm.value.erpState, this.filterForm.value.hasNoValidELV, this.filterForm.value.hasNoCard).subscribe((users: PagedResources<BusinessUserResource>) => {
          this.page = users.page
          users.content.forEach(user => {
            this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
              user['household'] = el;
            })
          });
          this.dataSource = new MatTableDataSource(users.content);
        })
      }
    })
  }

  downLoadUserDataAsZIP(customer: BusinessUserResource) {
    this.businessuserService.getDSGVOExport(customer).subscribe(val => {
      var a = document.createElement("a");
      const contentType = 'application/zip';
      const blob = new Blob([val], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = `${customer.person.displayName}_export`;
      a.click();
      window.URL.revokeObjectURL(url);
    })
  }

  addMemberViaDialog(user) {
    this.overlay.openAddHouseholdMemberDialog("Haushaltsmitglied anlegen", "", "Anlegen", user).subscribe(val => {
      this.ngOnInit();
    })
  }

  getMembers(user: BusinessUserResource) {
    if (user['household']) {

    } else {
      this.businessuserService.getGroupMemersByID(user.publicId).subscribe(el => {
        user['household'] = el;
      })
    }
  }

  openResetPassword(user) {
    this.overlay.openResetPWUserDialog("Passwort zurücksetzen", "", "Passwort setzen", user)
  }


  moveTocontact(user) {
    this.router.navigate(['contact', user.publicId])
  }

  onKeydown(event) {
    if (event.key === "Enter") {
      this.filterCustomers()
    }
  }


  startCardProcess(type:string, publicId:string){
    this.cardService.startCardProcess(type,publicId).subscribe({
      next: res =>{
        this.overlay.openSnackBar("Prozess erfolgreich gestartet");
      },
      error: err =>{
        if(err.status == 201){
          this.overlay.openSnackBar("Prozess erfolgreich gestartet");
        }else{
          this.overlay.openSnackBar("Fehler beim Starten des Prozesses, versuchen Sie es bitte später noch einmal.");

        }
      }
    })
  }


  deleteUser(user){
    this.overlay.openDelteUserDialog("Nutzer löschen","Nutzer wirklich löschen?","Nutzer löschen",user.publicId)
  }

  customerDisplayName(customer:BusinessUserResource):String{
    switch(environment.clientID){
      case 129 :{
        return `${customer.person?.lastName}  ${customer.person?.firstName}  (${customer.customerNumber})`
      }
      default:{
        return `${customer.person?.firstName}  ${customer.person?.lastName}  (${customer.customerNumber})`
      }
    }

  }

  syncWithERP(customer:BusinessUserResource){
    this.businessuserService.syncWithLemgoERP(customer).subscribe({
      next: (res:syncMessage) =>{
        this.overlay.openERPSyncMessagesDialog("Hinweis", "Ok", "abbrechen", res.messages).subscribe(val=>{
          this.filterCustomers();
        })
      },
      error: err =>{
        console.log(err)
      }
    })
  }
}


